module.exports = __webpack_public_path__ + "static/fichier-14-3dcc77c8d4f0f1a35d9b2ff33e2ec4f9.png";